import { render, staticRenderFns } from "./ttshop_addinvoice.vue?vue&type=template&id=e96e04a4&scoped=true&"
import script from "./ttshop_addinvoice.vue?vue&type=script&lang=js&"
export * from "./ttshop_addinvoice.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_addinvoice.vue?vue&type=style&index=0&id=e96e04a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96e04a4",
  null
  
)

export default component.exports